/* eslint-disable */
import {AxiosResponse} from 'axios';
import axios from 'utils/axios';
import MgecApi from 'mgec-jssdk';
import { session } from '@/utils/smart-storage'
const qs = require('qs');
// axios.defaults.withCredentials = true

interface IRequestOptions {
  url: string;
  method?: string;
  params?: any;
}

export default function networkRequest<T>({  //请求的时候类型要指定泛型，因为会有不同的接口类型参数
  url,
  method = 'get',
  params = null,
}: IRequestOptions): Promise<AxiosResponse> {
  const smKey = 'smrid_' + url.split('?')[0]
  const smrid = session.get<string>(smKey)
  if (smrid) {
    params = { ...params, smrid }
    session.remove(smKey)
  }
  const promise =
    method === 'post'
      ? axios({
          url,
          method,
          data: qs.stringify(params),
        })
      : axios.get(url, {
          params,
        })
  return promise.then(res => {
    const { code } = res.data || {}
    if (code === 2199) {
      MgecApi.callhandler('nativeSMCaptcha', {}, (res: any) => {
        if (typeof res === 'string') res = JSON.parse(res)
        if (+res.code === 200) {
          const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
          session.set(smKey, data.smrid, 5 * 60)
        }
      });
    }
    return res
  })
}
